import React, { useState, useEffect } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

export function AppFooter() {
  const [settings, setSettings] = useState({
    copyright_text: "Sport und Freizeit in Wilmersdorf e.V.",
    version: "V15",
    show_year: true,
    show_copyright: true,
    show_version: true
  });

  // Footer-Einstellungen laden
  useEffect(() => {
    const loadSettings = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/footer-settings`);
        setSettings(res.data);
      } catch (error) {
        console.error("Footer-Einstellungen konnten nicht geladen werden:", error);
      }
    };
    loadSettings();

    // Event-Listener für Updates aus den Einstellungen
    const handleUpdate = (e) => {
      if (e.detail) {
        setSettings(e.detail);
      }
    };
    window.addEventListener('footer-settings-updated', handleUpdate);
    
    return () => {
      window.removeEventListener('footer-settings-updated', handleUpdate);
    };
  }, []);

  // Footer-Text generieren
  const getFooterText = () => {
    const parts = [];
    if (settings.show_copyright) {
      if (settings.show_year) {
        parts.push(`© ${new Date().getFullYear()} ${settings.copyright_text}`);
      } else {
        parts.push(`© ${settings.copyright_text}`);
      }
    }
    if (settings.show_version && settings.version) {
      parts.push(`Version: ${settings.version}`);
    }
    return parts.join(" - ");
  };

  const footerText = getFooterText();

  // Nichts anzeigen, wenn keine Konfiguration
  if (!footerText) {
    return null;
  }

  return (
    <footer 
      className="w-full py-4 mt-8 border-t border-slate-200 bg-slate-50"
      data-testid="app-footer"
    >
      <div className="max-w-7xl mx-auto px-4 text-center">
        <p 
          className="text-slate-500"
          style={{ 
            fontSize: 'var(--font-small-size)', 
            fontWeight: 'var(--font-body-weight)',
            fontFamily: 'var(--font-primary)'
          }}
        >
          {footerText}
        </p>
      </div>
    </footer>
  );
}
